<template>
  <v-card class="iframeWrapper">
    <iframe @load="setSize" src="/forum"></iframe>
  </v-card>
</template>
<script>
export default {
  methods: {
    setSize (el) {
      let iframe = el.target
      iframe.height = iframe.contentWindow.document.body.scrollHeight + 50 + 'px'
    }
  }
}
</script>
<style>
.iframeWrapper {
	position: relative;
}
iframe {
  border: 0px;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Forum.vue